<template>
  <div
    key="footer"
    class="footer">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'componentsTemplatesFooter'
}
</script>
<style lang="scss" scoped>
.footer{
  width: 100%;
  bottom: 0;
  overflow: hidden;
  z-index: 100;
  height: 72px;
  border-top: 2px solid var(--v-secondary__green_chosen-base) !important;
  background-color: var(--color-main-green) !important;
  padding: 0 40px 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    font-weight: 600;
    letter-spacing: 0.03em;
  }
}
</style>
